import { Badge } from '../ui/badge';

const statusConfig = {
  pending: {
    label: 'Payment Pending',
    className: 'bg-amber-50 text-amber-800 border border-amber-200'
  },
  processing: {
    label: 'Processing',
    className: 'bg-cyan-50 text-cyan-900 border border-cyan-200'
  },
  paid: {
    label: 'Active',
    className: 'bg-emerald-50 text-emerald-900 border border-emerald-200'
  },
  completed: {
    label: 'Completed',
    className: 'bg-[#E6FAF8] text-[#0B1220] border border-[#BFF2F2]'
  },
  failed: {
    label: 'Failed',
    className: 'bg-red-50 text-red-900 border border-red-200'
  },
  refunded: {
    label: 'Refunded',
    className: 'bg-slate-50 text-slate-700 border border-slate-200'
  }
};

export default function StatusBadge({ status, className = '' }) {
  const config = statusConfig[status] || statusConfig.pending;
  
  return (
    <Badge 
      className={`${config.className} ${className}`}
      data-testid="review-status-badge"
    >
      {config.label}
    </Badge>
  );
}
